import {Concept} from 'types';
import type {Schema} from 'schemaDefinition/types';
import {Separator} from 'schemaDefinition/types';
import type {AgentPublisher} from 'services/agent/types';
import {translate} from 'localization';

export const agentPublisherSchema: Schema<AgentPublisher> = {
  name: 'publisher',
  key: 'publisher',
  parts: [
    {...Separator('card', 'line'), titleKey: 'nameVariants'},
    {
      type: 'nameVariant',
      agentType: Concept.publisher,
      name: 'nameVariants',
      cardinality: 'multiple',
      required: true,
    },
    {...Separator('card', 'line'), titleKey: 'personMoreInfo'},
    {
      type: 'text',
      name: 'id',
      readonly: true,
    },
    {
      type: 'expand',
      role: 'agentVerified',
      when: [
        {
          condition: {arg: {$ref: ':id'}},
          parts: [{type: 'bool', name: 'verified'}],
        },
      ],
    },
    [
      {
        type: 'text',
        name: 'place',
        required: true,
        validation: {
          level: 'warning',
          messageKey: 'placeNotIdentified',
          $not: {
            $eq: translate('form.errors.placeNotIdentified'),
          },
        },
      },
      {
        type: 'codelist',
        name: 'country',
        codelistId: 'COUNTRY',
      },
    ],
    {
      type: 'textarea',
      name: 'externalComments',
      maxLength: 5000,
    },
    {...Separator('card', 'line'), titleKey: 'internalComments'},
    {
      type: 'textarea',
      name: 'internalComments',
      maxLength: 5000,
    },
  ],
};
